import Api from './Api';

const Harvests = () => {
  return Api().get('/harvests');
};

const Harvest = (id) => {
  return Api().get(`/harvests/${id}`);
};

const AddHarvest = (data) => {
  return Api().post('/harvests', data);
};

const EditHarvest = (id, data) => {
  return Api().put(`/harvests/${id}`, data);
};

export { Harvests, Harvest, AddHarvest, EditHarvest };
